import { render, staticRenderFns } from "./CodeComponent.vue?vue&type=template&id=50a5e993&"
import script from "./CodeComponent.vue?vue&type=script&lang=js&"
export * from "./CodeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports